import React from 'react';
import { PRODUCT_TYPE_LABEL_MAP } from 'src/settings/settings';
import { UserFund } from 'src/types';
import { isProductType529 } from 'src/utils/funds/funds-utility';
import { trainCase } from 'src/utils/utils';

export const compareFunds = (a: UserFund, b: UserFund) => {
  const isCollege: boolean = isProductType529(a.productType);
  const transitionedProductType = isCollege !== isProductType529(b.productType);
  const firstOfClassification =
    transitionedProductType ||
    (isCollege
      ? b.formattedEntityNames !== a.formattedEntityNames
      : b.displayClassification !== a.displayClassification);

  const firstOfAgreement =
    transitionedProductType ||
    (isCollege
      ? b.productType !== a.productType
      : b.agreementType !== a.agreementType ||
        b.formattedEntityNames !== a.formattedEntityNames);

  const displayClassification = isCollege ? (
    <span className="blocked_data">{a.formattedEntityNames}</span>
  ) : (
    trainCase(a?.displayClassification ?? '')
  );

  const agreementType = isCollege
    ? PRODUCT_TYPE_LABEL_MAP[a.productType]
    : a.agreementType;

  return {
    displayClassification,
    agreementType,
    firstOfClassification,
    firstOfAgreement,
  };
};
